const imageUploadNote = ({ isExpanded }) =>
  isExpanded
    ? "Aspect: 3:2 | Minimum: 1863 x 1242 | Recommended: 1920 x 1280"
    : "Aspect: 5:4 | Minimum: 750 x 600"
export default imageUploadNote
